var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1442d06b-ba42-4a5c-85c8-b2b1e8ddd172",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.07 53.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-bface0df-d2c8-46b5-81ca-a0a71978cdbb {\n        fill: #4d4d4d;\n      }\n\n      .uuid-396102fa-a4e7-48ba-a512-c5909c927b5e {\n        fill: #999;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-d7992cf4-f643-4df5-8dfd-6c7227715aa1",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-396102fa-a4e7-48ba-a512-c5909c927b5e",
    width: 53.07,
    height: 53.07
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-bface0df-d2c8-46b5-81ca-a0a71978cdbb",
    d: "m23.55,25.96h5.97c6.49,0,11.76,5.27,11.76,11.76h0c0,2.78-2.25,5.03-5.03,5.03h-19.44c-2.78,0-5.03-2.25-5.03-5.03h0c0-6.49,5.27-11.76,11.76-11.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-bface0df-d2c8-46b5-81ca-a0a71978cdbb",
    cx: 26.53,
    cy: 16.75,
    r: 6.43
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/AvatarPlaceholder.a1a139b572bfc86e2cbf96b5ed76894c.svg";
export { ForwardRef as ReactComponent };